import React from "react";
import profile from "../../../assets/img/profile-pic.jpg";
import "./About.css";

function About(props) {
    return (
        <section id="about">
            <div className="container py-5">
                <div className="text-center my-3">
                    <h5 className="text-uppercase fw-bold">about</h5>
                    <h1
                        className="fw-bold"
                        style={{ fontSize: "2.5rem", color: "#313131" }}
                    >
                        Let me introduce myself.
                    </h1>
                </div>
                <div className="row justify-content-center py-3">
                    <div className="col-md-8 col">
                        <div className="d-flex flex-row">
                            <img
                                className="img-fluid rounded-circle"
                                style={{
                                    marginTop: "9px",
                                    height: "7rem",
                                    width: "7rem",
                                }}
                                src={profile}
                                alt=""
                            />
                            <p
                                className="lead"
                                style={{
                                    fontSize: "20px",
                                    paddingLeft: "4rem",
                                }}
                            >
                                Welcome to my portfolio! I am Ferdous
                                Hasan, a fresher in Full Stack Web Development,
                                specifically in React.js. <br />I am passionate
                                about creating innovative and user-friendly web
                                experiences that deliver results. I have a
                                strong foundation in JavaScript, HTML, CSS and
                                recently learned React.js and other
                                related technologies.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="row justify-content-center py-3">
                    <div className="col-lg-5 col-10">
                        <h4
                            style={{ letterSpacing: ".25rem" }}
                            className="poppins fw-bold text-uppercase"
                        >
                            Profile
                        </h4>
                        <p>
                        I am a passionate and skilled developer with a love for creating captivating digital experiences. Proficient in HTML, CSS, JavaScript, React.js, Node.js, Express.js, Bootstrap, and PHP, I possess the technical prowess to build innovative web applications. Additionally, my creative flair in Adobe Photoshop and Illustrator allows me to craft visually appealing designs. Explore my portfolio to see the fusion of technology and creativity, and let's collaborate on your next exciting project.
                        </p>

                        <ul className="info-list">
                            <li>
                                <strong className="poppins">Fullname:</strong>
                                <span>Ferdous Hasan Ador</span>
                            </li>
                            <li>
                                <strong className="poppins">Birth Date:</strong>
                                <span>June 06, 2001</span>
                            </li>
                            <li>
                                <strong className="poppins">Job:</strong>
                                <span>Full Stack Web Developer</span>
                            </li>
                            <li>
                                <strong className="poppins">LinkedIn:</strong>
                                <span>
                                    <a
                                        className="text-secondary text-decoration-none"
                                        href="https://www.linkedin.com/in/ferdous-hasan-dev/"
                                    >
                                        @ferdous-hasan-dev
                                    </a>
                                </span>
                            </li>
                            <li>
                                <strong className="poppins">Email:</strong>
                                <span>ferdous.hasan.cse@ulab.edu.bd</span>
                            </li>
                        </ul>
                    </div>
                    <div className="col-lg-5 col-10">
                        <h4
                            style={{ letterSpacing: ".25rem" }}
                            className="poppins fw-bold text-uppercase"
                        >
                            Skills
                        </h4>
                        <p>
                        Proficient in a wide range of technologies including HTML, CSS, and JavaScript, I build captivating web experiences that engage users. My expertise extends to React.js, Node.js, and Express.js, allowing me to create seamless and efficient applications. With a keen eye for design, I also harness Adobe Photoshop and Illustrator to craft visually stunning graphics and user interfaces. Let's combine technology and creativity to bring your projects to life.
                        </p>

                        <ul className="skill-bars">
                            <li>
                                <div class="progress percent80">
                                    <span>80%</span>
                                </div>
                                <strong>HTML5</strong>
                            </li>
                            <li>
                                <div class="progress percent70">
                                    <span>70%</span>
                                </div>
                                <strong>CSS3</strong>
                            </li>
                            <li>
                                <div class="progress percent80">
                                    <span>80%</span>
                                </div>
                                <strong>JavaScript</strong>
                            </li>
                            <li>
                                <div class="progress percent80">
                                    <span>80%</span>
                                </div>
                                <strong>React JS</strong>
                            </li>
                            <li>
                                <div class="progress percent70">
                                    <span>70%</span>
                                </div>
                                <strong>Node JS</strong>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 text-center">
                        <a
                            href="mailto: ferdous.hasan.cse@ulab.edu.bd"
                            title="Hire Me"
                            style={{
                                fontSize: "0.9rem",
                                letterSpacing: ".2rem",
                            }}
                            className="poppins text-uppercase fw-bold btn btn-light btn-lg border border-dark border-2 rounded-0 px-5 m-1"
                        >
                            Hire Me
                        </a>
                        <a
                            href="./assets/files/resume.pdf"
                            target="_blank"
                            title="Download CV"
                            style={{
                                fontSize: "0.9rem",
                                letterSpacing: ".2rem",
                            }}
                            className="poppins text-uppercase fw-bold btn btn-dark btn-lg border border-dark border-2 rounded-0 px-5 m-1"
                            download
                        >
                            Download CV
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default About;
